
	<a 
		class="card-link" 
		queryParamsHandling="merge" 
		[routerLink]="article.url"
		[queryParams]="article.page === 1 ? {} : { strana: article.page }"
	>
		<app-media 
			class="thumbnail" 
			kind="card" 
			[alt]="article.title" 
			[src]="article.field_image_url" 
		></app-media>	
		<app-icon class="type-icon" name="{{article.content_type}}" [shadow]="true" ></app-icon>
		<span class="title">
			<h2>{{ article.title }}</h2>
		</span>
	</a>

